import React, { createContext, useCallback, useContext, useState } from "react";

// In-memory only: full page refresh clears these results, sidebar navigation does not.
const AnalysisResultContext = createContext(null);

export function AnalysisResultProvider({ children }) {
  // AI Phishing Analysis. aiFile holds the pending selected email so the
  // upload survives sidebar navigation (cleared on removal / full refresh).
  const [aiResult, setAiResult] = useState(null);
  const [aiFile, setAiFile] = useState(null);
  const clearAiResult = useCallback(() => setAiResult(null), []);

  // Standard (Non-AI) Phishing Analysis
  const [standardResult, setStandardResult] = useState(null);
  const [standardFile, setStandardFile] = useState(null);
  const clearStandardResult = useCallback(() => setStandardResult(null), []);

  // Unified IoC Validator
  const [iocResult, setIocResult] = useState(null);
  const [iocInput, setIocInput] = useState("");
  const clearIocResult = useCallback(() => {
    setIocResult(null);
    setIocInput("");
  }, []);

  // Threat Hunt Query Generator
  // Stores the full result payload + the inputs that produced it
  const [queryGenResult, setQueryGenResult] = useState(null);
  const [queryGenInput, setQueryGenInput] = useState({ useCase: "", platforms: [] });
  const clearQueryGenResult = useCallback(() => {
    setQueryGenResult(null);
    setQueryGenInput({ useCase: "", platforms: [] });
  }, []);

  return (
    <AnalysisResultContext.Provider
      value={{
        aiResult,
        setAiResult,
        clearAiResult,
        aiFile,
        setAiFile,
        standardResult,
        setStandardResult,
        clearStandardResult,
        standardFile,
        setStandardFile,
        iocResult,
        setIocResult,
        iocInput,
        setIocInput,
        clearIocResult,
        queryGenResult,
        setQueryGenResult,
        queryGenInput,
        setQueryGenInput,
        clearQueryGenResult,
      }}
    >
      {children}
    </AnalysisResultContext.Provider>
  );
}

export function useAnalysisResult() {
  const ctx = useContext(AnalysisResultContext);
  if (!ctx) {
    throw new Error("useAnalysisResult must be used within an AnalysisResultProvider");
  }
  return ctx;
}
